import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  categoryName: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500,
    },
    color: colors.neutral[900],
    margin: [0],
    marginBottom: '0.4rem',
    textTransform: 'uppercase',
  },
  categoryWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: colors.neutral[700],
    borderBottom: '0.1rem solid #C1C7CD',
    marginBottom: '1rem',
  },
  shortButtonName: {
    padding: 0,
    width: '26rem',
    overflow: 'hidden',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '1.6rem',
    textAlign: 'left',
    '& > span': {
      width: '2.2rem',
      height: '2.2rem',
    },
  },
  fileWrapper: {
    marginBottom: '2.5rem',
    padding: '0.5rem 1rem',
    borderRadius: '0.6rem',
    backgroundColor: colors.blue[100],
    '& [data-role="tooltip-label"]': {
      maxWidth: '26rem',
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
    },
  },
  attachmentsWrapper: {
    marginBottom: '5rem',
  },
  fieldName: {
    textTransform: 'uppercase',
    color: colors.neutral[500],
    margin: 0,
    marginBottom: '1rem',
    font: {
      size: '1.4rem',
      lineHeight: '2rem',
      weight: 700,
    },
  },
  fieldValue: {
    margin: [0],
    marginBottom: '0.5rem',
    font: {
      size: '1.6rem',
      lineHeight: '2.8rem',
      weight: 400,
    },
  },
  renewalExhibitButton: {
    textTransform: 'uppercase',
    paddingLeft: 0,
    fontWeight: 700,
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
